// Simple i18n for Denva Post. Hindi is default; English is a UI-toggle overlay.
// Article body content stays in the language the reporter wrote (Hindi).

export const DICT = {
  hi: {
    // header
    home: "होम",
    videos: "वीडियो",
    search: "खोजें",
    subscribe: "सदस्य बनें",
    exclusive_link: "एक्सक्लूसिव",
    epaper: "ई-पेपर",
    about: "हमारे बारे में",
    contact: "संपर्क",
    tagline: "भरोसे की पत्रकारिता",
    lang_toggle_label: "भाषा",
    // article
    all_news: "सभी खबरें",
    share_this: "यह खबर शेयर करें",
    news_desk: "समाचार डेस्क",
    published_in_hindi_note:
      "यह खबर मूल रूप से हिंदी में प्रकाशित है — सटीक अर्थ के लिए हिंदी संस्करण देखें।",
    // author
    author_page_title: "लेखक",
    articles_by: "इनकी खबरें",
    total_articles: "कुल खबरें",
    view_all_authors: "सभी लेखक",
    no_articles: "अभी कोई खबर उपलब्ध नहीं",
    back: "वापस",
    // 404
    not_found: "यह खबर उपलब्ध नहीं है या हटा दी गई है।",
    go_home: "होम पर लौटें",
    // sections (some already Hindi in DB — we override display only in EN mode)
  },
  en: {
    home: "Home",
    videos: "Videos",
    search: "Search",
    subscribe: "Subscribe",
    exclusive_link: "Exclusive",
    epaper: "E-Paper",
    about: "About",
    contact: "Contact",
    tagline: "Journalism you can trust",
    lang_toggle_label: "Language",
    all_news: "All news",
    share_this: "Share this story",
    news_desk: "News Desk",
    published_in_hindi_note:
      "This story was originally published in Hindi — refer to the Hindi version for precise meaning.",
    author_page_title: "Author",
    articles_by: "Stories by",
    total_articles: "Total stories",
    view_all_authors: "All authors",
    no_articles: "No stories yet",
    back: "Back",
    not_found: "This story is not available or has been removed.",
    go_home: "Return home",
  },
};

// Category labels for Header nav (matches backend CATEGORY keys)
export const CATEGORY_LABEL_MAP = {
  home: { hi: "होम", en: "Home" },
  narmadapuram: { hi: "नर्मदापुरम", en: "Narmadapuram" },
  mp: { hi: "मध्यप्रदेश", en: "Madhya Pradesh" },
  national: { hi: "देश-दुनिया", en: "National & World" },
  politics: { hi: "राजनीति", en: "Politics" },
  rajkaj: { hi: "जनसंपर्क", en: "Jansampark" },
  edujobs: { hi: "शिक्षा-रोजगार", en: "Education & Jobs" },
  utility: { hi: "काम की बात", en: "Utility" },
  sportsent: { hi: "खेल-मनोरंजन", en: "Sports & Entertainment" },
  religion: { hi: "धर्म संस्कृति", en: "Faith & Culture" },
  exclusive: { hi: "देनवा एक्सक्लूसिव", en: "Denva Exclusive" },
};
